export default "__VITE_ASSET__CucPHOL$__"